import request from "./request"

export function getChannels() {
  return request({ url: "/content/channel_list_get", method: "get" })
}

export function getFeed(params) {
  return request({ url: "/content/feed_get", method: "get", params })
}

export function getVideoDetail(params) {
  return request({ url: "/content/detail_get", method: "get", params })
}

export function getLiveStream(params) {
  return request({ url: "/content/live_stream_get", method: "get", params })
}

export function createLiveRoomWsTicket(data) {
  return request({ url: "/content/live_room_ws_ticket_create", method: "post", data, silentError: true })
}

export function getLiveGifts(params) {
  return request({ url: "/content/live_gift_list_get", method: "get", params, silentError: true })
}

export function getLiveEntrances(params) {
  return request({ url: "/content/live_entrance_list_get", method: "get", params, silentError: true })
}

export function addLiveEntrance(data) {
  return request({ url: "/content/live_entrance_add", method: "post", data, silentError: true })
}

export function getLiveChat(params) {
  return request({ url: "/content/live_chat_list_get", method: "get", params, silentError: true })
}

export function addLiveChat(data) {
  return request({ url: "/content/live_chat_add", method: "post", data })
}

export function getLiveLikes(params) {
  return request({ url: "/content/live_like_list_get", method: "get", params, silentError: true })
}

export function addLiveLikes(data) {
  return request({ url: "/content/live_like_add", method: "post", data, silentError: true })
}

export function updateLivePresence(data) {
  return request({ url: "/content/live_presence_update", method: "post", data, silentError: true })
}

export function getLiveViewers(params) {
  return request({ url: "/content/live_viewer_list_get", method: "get", params, silentError: true })
}

export function getAuthor(params) {
  return request({ url: "/content/author_get", method: "get", params })
}

export function addWatch(data) {
  // 播放埋点属于后台辅助请求，失败不应打断用户观看或弹出全局错误。
  return request({ url: "/content/watch_add", method: "post", data, silentError: true })
}

export function updateAction(data) {
  return request({ url: "/content/action_update", method: "post", data })
}

export function updateFollow(data) {
  return request({ url: "/content/follow_update", method: "post", data })
}

export function updateUserFollow(data) {
  return request({ url: "/content/user_follow_update", method: "post", data })
}

export function getComments(params) {
  return request({ url: "/content/comment_list_get", method: "get", params })
}

export function addComment(data) {
  return request({ url: "/content/comment_add", method: "post", data })
}

export function deleteComment(data) {
  return request({ url: "/content/comment_delete", method: "post", data })
}

export function updateCommentLike(data) {
  return request({ url: "/content/comment_like_update", method: "post", data })
}

export function addShare(data) {
  return request({ url: "/content/share_add", method: "post", data })
}

export function addReport(data) {
  return request({ url: "/content/report_add", method: "post", data })
}

export function updateBlock(data) {
  return request({ url: "/content/block_update", method: "post", data })
}
